import { FC } from 'react';
import { Anchor, Breadcrumbs as MantineBreadcrumbs } from '@mantine/core';
import Link from 'next/link';

interface Props {
	items: {
		label: string;
		href: string;
	}[];
}

export const Breadcrumbs: FC<Props> = ({ items }) => {
	return (
		<MantineBreadcrumbs mb="lg">
			<Anchor component={Link} href="/">
				Strona główna
			</Anchor>
			{items.map((item, index, array) => (
				<Anchor
					key={index}
					component={Link}
					href={item.href}
					fw={index === array.length - 1 ? 'bold' : undefined}
					c={index === array.length - 1 ? 'black' : undefined}
				>
					{item.label}
				</Anchor>
			))}
		</MantineBreadcrumbs>
	);
};
